import { Component } from '@angular/core';
import { ErrorCodeComponent } from './error-code.component';

@Component({
  selector: 'app-error-403',
  template: `
    <app-error-code
      code="403"
      title="Permission denied!"
      message="You do not have permission to access the requested data."
    />
  `,
  imports: [ErrorCodeComponent],
})
export class Error403Component {}
